import React, { type FunctionComponent } from 'react'
import { type ActiveFeedStatus, ACTIVE_FEED_STATUS_LABELS, INACTIVE_INTEGRATION_STATUS } from '../../../types'
import { StatusChipIcon, StatusChipWrapper } from './status-chip.styles'

type StatusChipProps = {
    status: ActiveFeedStatus | typeof INACTIVE_INTEGRATION_STATUS,
}

export const StatusChip: FunctionComponent<StatusChipProps> = ( { status } ) => {
	return (
		<StatusChipWrapper
			label={ACTIVE_FEED_STATUS_LABELS[ status ]}
			status={status}
			icon={
				<StatusChipIcon status={status} />
			}
		/>
	)
}
